import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, unref as _unref, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "margin-b-standard is-relative" }
const _hoisted_2 = { class: "toggle-check" }
const _hoisted_3 = ["value"]

import Collapse from "@/components/right-sidebars/ui/Collapse.vue";
import RightSidebarTitle from "@/components/right-sidebars/ui/RightSidebarTitle.vue";
import ContentLocationPath from "@/components/right-sidebars/content-sidebar/content-location/ContentLocationPath.vue";
import { mdiLinkVariant, mdiPencil } from "@mdi/js";
import { computed, PropType, ref } from "vue";
import { useUIContentStore } from "@/stores/ui-content.store";
import { ProductItem } from "@/models/product.model";
import { AssetLocation } from "@/models/assets.model";
import { getExternalPath, getInternalPath } from "@/utils/content-path-helpers";
import { copyToClipboard } from "@/services/copy-to-clipboard";


export default /*#__PURE__*/_defineComponent({
  __name: 'ContentLocation',
  props: {
  product: {
    required: true,
    type: Object as PropType<ProductItem>
  },
  path: {
    required: true,
    type: Array as PropType<AssetLocation[]>
  },
  sectionName: {
    required: true,
    type: String
  },
  sectionId: {
    required: true,
    type: Number
  },
  sectionIconId: {
    required: true,
    type: Number
  },
  sectionExternalId: {
    required: true,
    type: String
  },
  canEditContent: {
    required: true,
    type: Boolean
  }
},
  setup(__props) {

const uiContentStore = useUIContentStore();

const props = __props;

const isLongPathNameEnabled = ref<boolean>(true);
const isEditButtonVisible = computed<boolean>(() => {
  // user can move section, if product contains not only root section and current section
  return props.canEditContent && props.product.sections.length > 2;
});
const externalPath = computed<string>(() => {
  return getExternalPath(
    props.path,
    props.product.name,
    props.sectionExternalId
  );
});
const internalPath = computed<string>(() => {
  return getInternalPath(props.path, props.product.name, props.sectionName);
});

return (_ctx: any,_cache: any) => {
  const _component_SVGIcon = _resolveComponent("SVGIcon")!

  return (_openBlock(), _createBlock(Collapse, null, {
    title: _withCtx(() => _cache[4] || (_cache[4] = [
      _createElementVNode("span", null, "Path", -1)
    ])),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(RightSidebarTitle, { title: 'Internal path' }),
        _createElementVNode("label", _hoisted_2, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            "aria-label": "edit",
            value: isLongPathNameEnabled.value,
            "data-testing": "toggle-edit-mode",
            class: "editable",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isLongPathNameEnabled).value = $event))
          }, null, 8, _hoisted_3), [
            [_vModelCheckbox, isLongPathNameEnabled.value]
          ]),
          _cache[5] || (_cache[5] = _createElementVNode("span", {
            "data-on-text": "Long path name",
            "data-off-text": "Short path name"
          }, null, -1))
        ]),
        _createVNode(ContentLocationPath, {
          product: __props.product,
          path: __props.path,
          "section-name": __props.sectionName,
          "section-id": __props.sectionId,
          "section-icon-id": __props.sectionIconId,
          "section-external-id": __props.sectionExternalId,
          "is-long-path-name-enabled": isLongPathNameEnabled.value
        }, null, 8, ["product", "path", "section-name", "section-id", "section-icon-id", "section-external-id", "is-long-path-name-enabled"]),
        _createElementVNode("button", {
          class: "btn-3",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(copyToClipboard)(internalPath.value)))
        }, [
          _createVNode(_component_SVGIcon, { path: _unref(mdiLinkVariant) }, null, 8, ["path"]),
          _cache[6] || (_cache[6] = _createTextVNode(" Copy "))
        ]),
        (isEditButtonVisible.value)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "btn-3 margin-l-standard",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(uiContentStore).openEditContentPathModal && _unref(uiContentStore).openEditContentPathModal(...args)))
            }, [
              _createVNode(_component_SVGIcon, {
                path: _unref(mdiPencil),
                size: 16
              }, null, 8, ["path"]),
              _cache[7] || (_cache[7] = _createTextVNode(" Edit "))
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", null, [
        _createVNode(RightSidebarTitle, { title: 'External path reference' }),
        _createVNode(ContentLocationPath, {
          product: __props.product,
          path: __props.path,
          "section-name": __props.sectionName,
          "section-id": __props.sectionId,
          "section-icon-id": __props.sectionIconId,
          "section-external-id": __props.sectionExternalId,
          "show-as-external": true,
          "is-long-path-name-enabled": false
        }, null, 8, ["product", "path", "section-name", "section-id", "section-icon-id", "section-external-id"]),
        _createElementVNode("button", {
          class: "btn-3",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(copyToClipboard)(externalPath.value)))
        }, [
          _createVNode(_component_SVGIcon, {
            path: _unref(mdiLinkVariant),
            size: 16
          }, null, 8, ["path"]),
          _cache[8] || (_cache[8] = _createTextVNode(" Copy "))
        ])
      ])
    ]),
    _: 1
  }))
}
}

})